import { Component } from 'react';
import PropTypes from 'prop-types';

import equal from 'fast-deep-equal';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// This component wraps and defaults some functionality of sweetalert2
// For full documentation and usable props visit: https://sweetalert2.github.io
export default class SweetAlert extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      reactSwal: withReactContent(Swal),
    };

    this.onOpen = this.onOpen.bind(this);
    this.onImageLoad = this.onImageLoad.bind(this);
  }

  componentDidMount() {
    this.fire();
  }

  componentDidUpdate(prevProps) {
    const { trigger, ...props } = this.props;
    const { isOpen } = this.state;

    if (!equal(this.props, prevProps) && trigger) {
      this.fire({ ...props });
    }

    if (isOpen !== trigger) {
      this.setState({ isOpen: trigger });
    }
  }

  componentWillUnmount() {
    const img = document.querySelector('img');
    if (img) img.removeEventListener('load', this.onImageLoad);
  }

  // static contextType = ContextProvider;

  onImageLoad({ target }) {
    const { imageLoad, imageLoadedStyle } = this.props;

    imageLoad();
    Object.assign(target.style, imageLoadedStyle);
  }

  onOpen(element) {
    const { imageStyle, imageLoad } = this.props;

    const img = element.querySelector('img');
    if (img) {
      if (imageStyle) Object.assign(img.style, imageStyle);
      if (imageLoad) img.addEventListener('load', this.onImageLoad);
    }
  }

  fire() {
    const { isOpen, reactSwal } = this.state;
    const {
      trigger, onClose, imageLoad, imageStyle, imageLoadedStyle, ...props
    } = this.props;
    // console.log({ context: this.context });

    if (trigger && !isOpen) {
      this.setState({ isOpen: true }, () => {
        reactSwal.fire({
          onOpen: this.onOpen,
          onDestroy: () => {
            this.setState({
              reactSwal: withReactContent(Swal),
              isOpen: false,
            });
          },
          ...props,
        }).then((e) => {
          this.setState({
            reactSwal: withReactContent(Swal),
            isOpen: false,
          }, () => onClose(e));
        });
      });
    }
  }

  render() { return null; }
}

SweetAlert.propTypes = {
  imageLoad: PropTypes.func,
  imageLoadedStyle: PropTypes.shape(),
  imageStyle: PropTypes.shape(),
  onClose: PropTypes.func,
  trigger: PropTypes.bool,
};

SweetAlert.defaultProps = {
  imageLoad: null,
  imageLoadedStyle: null,
  imageStyle: null,
  onClose: () => { },
  trigger: false,
};
